import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { FormattedMessage } from "react-intl";

interface DeleteUserDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteUserDialog({
  open,
  onClose,
  onConfirm,
}: DeleteUserDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <FormattedMessage id="admin.dashboard.deleteConfirmTitle" />
      </DialogTitle>
      <DialogContent>
        <Typography>
          <FormattedMessage id="admin.dashboard.deleteConfirmMessage" />
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          <FormattedMessage id="admin.dashboard.cancel" />
        </Button>
        <Button onClick={onConfirm} autoFocus>
          <FormattedMessage id="admin.dashboard.confirm" />
        </Button>
      </DialogActions>
    </Dialog>
  );
}
